(function(){
  var root=document.getElementById('oc-bk'); if(!root) return;
  var handle=root.getAttribute('data-product');
  var boxes=root.querySelectorAll('input[name="oc-service"]'), car=root.querySelector('#oc-car'), note=root.querySelector('#oc-note'), sum=root.querySelector('#oc-sum');
  var cal=root.querySelector('#oc-cal'), pick=root.querySelector('#oc-pick'), when=root.querySelector('#oc-when'), go=root.querySelector('#oc-go'), hint=root.querySelector('#oc-hint'), seg=root.querySelector('#oc-seg');
  var days={}, sel=null, arrival='No preference', view=null, minM=null, maxM=null;
  var MN=['January','February','March','April','May','June','July','August','September','October','November','December'];
  var DN=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  function iso(y,m,d){return y+'-'+('0'+(m+1)).slice(-2)+'-'+('0'+d).slice(-2)}
  function services(){var s=[];boxes.forEach(function(b){if(b.checked)s.push(b.value)});return s}
  function money(c){return '$'+(c/100).toFixed(c%100?2:0)}
  function pretty(k){var p=k.split('-');var d=new Date(+p[0],+p[1]-1,+p[2]);return DN[d.getDay()]+', '+MN[d.getMonth()]+' '+d.getDate()}
  function renderSum(){
    var s=services();
    sum.innerHTML=s.length?'<b>'+s.length+' selected:</b> '+s.map(esc).join(', '):'Select the services you want. You can pick more than one.';
    update();
  }
  function update(){
    if(!sel){go.disabled=true;return}
    var s=services(), d=days[sel];
    when.textContent=pretty(sel)+' · '+money(d.price)+' deposit';
    go.disabled=!s.length;
    if(!go.dataset.busy){hint.className='hint';hint.textContent=s.length?'You will finish payment at checkout.':'Pick at least one service to continue.'}
  }
  function draw(){
    var y=view.getFullYear(), m=view.getMonth(), first=new Date(y,m,1), off=(first.getDay()+6)%7, n=new Date(y,m+1,0).getDate();
    var h='<div class="calhead"><strong>'+MN[m]+' '+y+'</strong><div class="nav"><button type="button" id="oc-prev" aria-label="Previous month"'+(view<=minM?' disabled':'')+'>&#8249;</button><button type="button" id="oc-next" aria-label="Next month"'+(view>=maxM?' disabled':'')+'>&#8250;</button></div></div>';
    h+='<div class="dow"><span>M</span><span>T</span><span>W</span><span>T</span><span>F</span><span>S</span><span>S</span></div><div class="days">';
    for(var i=0;i<off;i++)h+='<span class="day empty"></span>';
    for(var d=1;d<=n;d++){
      var k=iso(y,m,d), v=days[k], c='off';
      if(v)c=v.av?'av':'bk';
      if(sel===k)c+=' sel';
      h+='<button type="button" class="day '+c+'" data-k="'+k+'"'+(v&&v.av?'':' disabled')+'>'+d+'</button>';
    }
    h+='</div>';
    cal.innerHTML=h;
    cal.querySelector('#oc-prev').onclick=function(){view=new Date(y,m-1,1);draw()};
    cal.querySelector('#oc-next').onclick=function(){view=new Date(y,m+1,1);draw()};
    cal.querySelectorAll('.day.av').forEach(function(b){b.onclick=function(){sel=b.getAttribute('data-k');pick.hidden=false;draw();update()}});
  }
  function load(){
    return fetch('/products/'+handle+'.js',{cache:'no-store'}).then(function(r){if(!r.ok)throw 0;return r.json()}).then(function(p){
      days={};var keys=[];
      p.variants.forEach(function(v){days[v.option1]={id:v.id,av:v.available,price:v.price};keys.push(v.option1)});
      keys.sort();
      if(sel&&(!days[sel]||!days[sel].av)){sel=null;pick.hidden=true}
      var f=keys[0].split('-'), l=keys[keys.length-1].split('-');
      minM=new Date(+f[0],+f[1]-1,1); maxM=new Date(+l[0],+l[1]-1,1);
      if(!view)view=new Date(minM);
      draw();
    });
  }
  load().catch(function(){cal.innerHTML='<p class="sub">Online booking is not available yet. Please message us to book.</p>'});
  boxes.forEach(function(b){b.addEventListener('change',renderSum)});
  seg.querySelectorAll('button').forEach(function(b){b.onclick=function(){seg.querySelectorAll('button').forEach(function(x){x.classList.remove('on')});b.classList.add('on');arrival=b.getAttribute('data-v')}});
  function fail(msg){go.disabled=false;go.textContent='Pay deposit & book';delete go.dataset.busy;hint.className='hint err';hint.textContent=msg}
  go.onclick=function(){
    if(!sel||!services().length)return;
    go.disabled=true;go.dataset.busy='1';go.textContent='One moment...';hint.className='hint';hint.textContent='';
    var v=days[sel], props={'Install date':pretty(sel),'Services':services().join(', '),'Preferred arrival':arrival};
    if(car.value.trim())props['Vehicle']=car.value.trim();
    if(note.value.trim())props['Note']=note.value.trim();
    var headers={'Content-Type':'application/json','Accept':'application/json'};
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      var up={};c.items.forEach(function(it){if(it.handle===handle)up[it.key]=0});
      if(Object.keys(up).length)return fetch('/cart/update.js',{method:'POST',headers:headers,body:JSON.stringify({updates:up})});
    }).then(function(){
      return fetch('/cart/add.js',{method:'POST',headers:headers,body:JSON.stringify({items:[{id:v.id,quantity:1,properties:props}]})});
    }).then(function(r){
      if(!r.ok){return load().then(function(){fail('Sorry, that day was just booked. Please pick another.')})}
      window.location.href='/checkout';
    }).catch(function(){fail('Something went wrong. Please try again.')});
  };
})();